"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stripCacheKeysFromData;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var CACHE_KEY = '__typename';

function stripCacheKeysFromObj(data) {
  return Object.keys(data).reduce(function (newData, dataKey) {
    if (dataKey === CACHE_KEY) {
      return newData;
    }

    var dataItem = data[dataKey];

    if (dataItem && (_typeof(dataItem) === 'object' || Array.isArray(dataItem))) {
      return _objectSpread({}, newData, _defineProperty({}, dataKey, stripCacheKeysFromData(dataItem)));
    }

    return _objectSpread({}, newData, _defineProperty({}, dataKey, dataItem));
  }, {});
}
/**
 * Strips apollo cache keys from a data object. Useful when using data from
 * the cache and then sending it to the API. Will remove cached keys from any level recursively.
 *
 * @param {Object | Array<Object>} data
 *
 * @return {Object | Array<Object>}
 */


function stripCacheKeysFromData(data) {
  var isArray = Array.isArray(data);

  if (!isArray && _typeof(data) !== 'object') {
    return data;
  }

  if (isArray) {
    return data.map(function (item) {
      return stripCacheKeysFromData(item);
    });
  }

  return stripCacheKeysFromObj(data);
}